import React from 'react'
import { Grid, Image, AutoCenter } from 'antd-mobile';
import Icon from '../../icon';


const SubTeamList = ({ gameDetail }) => {

    const getLogoInfo = (team) => {
        if (team === 1) {
            if (gameDetail.greenTeamLogo) {
                return gameDetail.greenTeamLogo + Icon.ImageFooter
            } else {
                return Icon.KEPENG_LOGO
            }
        } else if (team === 2) {
            if ([1,2].includes(gameDetail?.gameType)&& gameDetail?.redCaptain?.image) {
                return gameDetail.redCaptain.image
            } else if (gameDetail.redTeamLogo) {
                return gameDetail.redTeamLogo + Icon.ImageFooter
            } else {
                return Icon.KEPENG_LOGO
            }
        }
    }


    const getGameName = (teamIndex) => {
        if (teamIndex === 1) {
            if (gameDetail?.greenName) return gameDetail.greenName;
            if (gameDetail?.gameType === 2) return "华西科朋足球队";
            if (gameDetail?.greenCaptain?.name) return gameDetail.greenCaptain.name.charAt(0) + '队';
            return 'A队';
        } else if (teamIndex === 2) {
            if (gameDetail?.redName) return gameDetail.redName;
            if (gameDetail?.redCaptain?.name) return gameDetail.redCaptain.name.charAt(0) + '队';
            return 'B队';
        }
        return 'Team'
    }


    return (
        <div>
            <Grid columns={3} style={{ marginTop: '20px' }}>
                <Grid.Item>
                    <AutoCenter>
                        <Image
                            src={getLogoInfo(1)}
                            width={40}
                            height={40}
                            fit='cover'
                            style={{
                                borderRadius: 50, border:
                                    gameDetail && gameDetail.greenColor ?
                                        '5px solid ' + gameDetail.greenColor :
                                        '5px solid green'
                            }}
                        />
                    </AutoCenter>
                    <AutoCenter>
                        <span style={{ fontSize: '14px', fontWeight: '600' }}>
                            {getGameName(1)}
                        </span>
                    </AutoCenter>
                </Grid.Item>
                <Grid.Item style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '14px',
                    fontWeight: '600'
                }}>
                    <span>
                        {gameDetail.startDate}
                    </span>
                    <span>
                        {gameDetail.week}
                    </span>
                </Grid.Item>
                <Grid.Item>
                    <AutoCenter>
                        <Image
                            src={getLogoInfo(2)}
                            width={40}
                            height={40}
                            fit='cover'
                            style={{
                                borderRadius: 50, border:
                                    gameDetail && gameDetail.redColor ?
                                        '5px solid ' + gameDetail.redColor :
                                        '5px solid red'
                            }}
                        />
                    </AutoCenter>
                    <AutoCenter>
                        <span style={{ fontSize: '14px', fontWeight: '600' }}>
                            {getGameName(2)}
                        </span>
                    </AutoCenter>
                </Grid.Item>
            </Grid>
        </div>
    )
}


export default SubTeamList;